export default __webpack_public_path__ + "static/img_1_1-f52e5386e03197635a6677504309f2e6.webp";